module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("a96eb"))).then(() => parcelRequire('fThBo'));